import { Eye, File as FileIcon, FileText, FileVideo, Image as ImageIcon, ListChecks, Lock, Trash2 } from 'lucide-react';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useAuthHeader, useAuthUser } from 'react-auth-kit';
import User from '../../Models/User';
import datas from "../../Assets/data.json";
import env from 'react-dotenv';
import { Crypter } from '../../Functions/Security/Crypter';
import NewPub from './NewPub';
import FormPubUpdate from './FormPubUpdate';
import UpdatePub from './UpdatePub';
import { useAlert, Button, IconButton, Spin, Badge, Modal, DataTable, SearchInput, FormDrawer, TableStatusBar, InfoBar, PageHeader } from '../ui';
import { DataTableColumn } from '../ui/DataTable';

export default function ContenuPub() {
    // USER TOKEN
    const authHeader = useAuthHeader()
    // USER SESSION
    const auth = useAuthUser()
    const user: User = JSON.parse(JSON.stringify(auth() || {}))
    const alert = useAlert();

    const [data, setData] = useState([])

    const [arrierePlan, setArrierePlan] = useState([])
    const [services, setservices] = useState([])
    const [arrierePlanSelected, setArrierePlanSelected] = useState<any>()

    const [dataTri, setDataTri] = useState<any>([])

    const [loading, selLoading] = useState(false)

    const [fileToUpdate, setFileToUpdate] = useState()
    const [textRes, setTextRes] = useState("")

    useEffect(() => {
        LoadData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function LoadData() {
        selLoading(true)
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: env.API_BASE_URL + datas.API_LINKs.Pub.GetManagePub + '?CipherCodeU=' + Crypter.encrypt(user.CodeU),
            headers: {
                'Accept': 'text/plain',
                'Authorization': authHeader(),
            }
        };

        axios.request(config)
            .then((response: any) => {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value
                // alert(JSON.stringify(res))
                if (res.StatutCode == 200) {
                    selLoading(false)

                    const Pubs: any = []
                    const ap: any = []

                    res.Result[0].map((g: any) => {
                        // if (g.Statut != 3) {

                        // }
                        // Type MIME du 1er média (Fichiers = JSON array ou dataURL seul)
                        const raw = g.Fichiers || g.FIchiers || ''
                        let first = raw
                        try { const p = JSON.parse(raw); if (Array.isArray(p)) first = p[0] || '' } catch { }
                        const mime = (first || '').split(';')[0].split(':')[1] || ''
                        Pubs.push({ id: g.PubID, PubID: g.PubID, Titre: g.Titre, DateCreated: g.DateCreated, DatePub: g.DatePub, Statut: g.IsActif, services: g.PubID, Actions: g.PubID, FIchiers: g.PubID, FileType: mime }
                        )
                        ap.push({ id: g.PubID, ModifDate: g.ModifDate, UpdateCount: g.UpdateCount, CreatedBy: g.CreatedBy, IsActif: g.IsActif == 1 ? 'Oui' : 'Non' })
                    })

                    // alert(JSON.stringify(res.Result[1]))

                    setDataTri(Pubs)
                    setArrierePlan(ap)
                    setservices(res.Result[1])


                }
                else {
                    selLoading(false)
                    setDataTri([])
                    //localStorage.setItem("tabGuichet", JSON.stringify([]))
                    setTextRes("")
                    alert.warning(response.data.message)
                }
            })
            .catch((error: any) => {
                setTextRes("")
                alert.error('Error', error)
                selLoading(false)
                console.log(error);
            });
    }

    function tri(type: string) {

        var dte: any[] = []
        if (type == "a") {
            dte = data
        } else {
            data.map((el: any) => {
                if (el.Statut == type) {
                    dte.push(el)
                }
            })

        }
        setDataTri(dte)

        setTextRes(dte.length + " Resultat(s) obtenu")

    }
    const [openFileModal, setOpenFileModal] = useState(false);
    const [filesToView, setFilesToView] = useState<string[]>([]);

    // Modal services d'une pub (colonne tableau)
    const [openServicesModal, setOpenServicesModal] = useState(false)
    const [servicesPub, setServicesPub] = useState<any[]>([])
    const [servicesPubTitre, setServicesPubTitre] = useState('')


    function viewFile(PubID: string) {

        selLoading(true)
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: env.API_BASE_URL + datas.API_LINKs.Pub.GetFichiersByPubID + '?CipherPubID=' + Crypter.encrypt(PubID),
            headers: {
                'Accept': 'text/plain',
                'Authorization': authHeader(),
            }
        };

        axios.request(config)
            .then((response: any) => {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value
                // alert(JSON.stringify(res))
                if (res.StatutCode == 200) {
                    selLoading(false)
                    const raw = res.Result[0][0].FIchiers || res.Result[0][0].Fichiers || ''
                    // Fichiers = JSON array de médias ou dataURL seul
                    let medias: string[] = []
                    try { const p = JSON.parse(raw); medias = Array.isArray(p) ? p : [raw] } catch { if (raw) medias = [raw] }
                    setFilesToView(medias)

                    setOpenFileModal(true);

                }
                else {
                    selLoading(false)
                    setDataTri([])
                    //localStorage.setItem("tabGuichet", JSON.stringify([]))
                    setTextRes("")
                    alert.warning(response.data.message)
                }
            })
            .catch((error: any) => {
                setTextRes("")
                alert.error('Error', error)
                selLoading(false)
                console.log(error);
            });
    }

    /** Icône selon le type MIME du fichier de la pub. */
    const fileIcon = (mime?: string) =>
        mime?.startsWith('image/') ? <ImageIcon size={16} />
        : mime?.startsWith('video/') ? <FileVideo size={16} />
        : mime === 'application/pdf' ? <FileText size={16} />
        : mime ? <FileIcon size={16} />
        : <Eye size={16} />

    const columns: DataTableColumn[] =
        [
            {
                field: 'FIchiers', headerName: 'Fichier', width: 130, renderCell: ({ value, row }) => (
                    <div>
                        <Button startIcon={fileIcon(row.FileType)} variant="outline" size="sm" onClick={() => { viewFile(value) }}>
                            Voir
                        </Button>
                    </div>
                ),
            },
            { field: 'PubID', headerName: 'Code Pub', width: 150 },
            { field: 'Titre', headerName: 'Titre', width: 150 },
            { field: 'DateCreated', headerName: 'Date création', width: 150 },
            { field: 'DatePub', headerName: 'Date Publication', width: 150 },
            {
                field: 'Statut', headerName: 'Statut', width: 70, renderCell: (record) => (
                    <Badge color={record.value == 1 ? "blue" : "red"}>
                        {record.value == 1 ? "Actif" : "Désactivé"}
                    </Badge>
                ),
            },
            {
                field: 'services', headerName: 'Services', width: 130, sortable: false,
                renderCell: ({ value, row }) => {
                    const list = services.filter((h: any) => h.PubID == value)
                    return (
                        <Button
                            variant="outline" size="sm" startIcon={<ListChecks size={15} />}
                            disabled={list.length === 0}
                            onClick={(e) => {
                                e.stopPropagation();
                                setServicesPub(list)
                                setServicesPubTitre(row.Titre || value)
                                setOpenServicesModal(true)
                            }}>
                            {list.length} service{list.length > 1 ? 's' : ''}
                        </Button>
                    )
                },
            },
            {
                field: 'Actions', headerName: 'Actions', width: 150,
                renderCell: (record) => (
                    <div className="flex items-center gap-2">
                        <IconButton tooltip='Retirer de la file' color='danger' size={32}><Trash2 size={16} /></IconButton>
                        <UpdatePub handleFunction={() => { LoadData() }} Pub={[dataTri.find((ar: any) => (ar.id == record.value)), services.filter((ha: any) => (ha.PubID == record.value))]} />
                        <IconButton tooltip='Bloquer' size={32}><Lock size={16} /></IconButton>
                    </div>
                ),
            },
        ];

    function handleRowClick(e: any) {
        setArrierePlanSelected(arrierePlan.find((ar: any) => (ar.id == e.id)))
    }

    const [open, setOpen] = useState(false)
    const [Pub, setPub] = useState<any>()

    const handleClose = () => {
        setOpen(false);
    };

    const renderFilePreview = (fileType: string, base64: string) => {
        if (fileType.startsWith('image/')) {
            return <img style={{ width: '100%' }} src={base64} alt="preview" />;
        } else if (fileType.startsWith('video/')) {
            return <video style={{ width: '100%' }} controls>
                <source src={base64} type={fileType} />
                Your browser does not support the video tag.
            </video>;
        } else if (fileType === 'application/pdf') {
            return <iframe style={{ width: '100%', height: '500px' }} src={base64} title="PDF preview" />;
        } else {
            return <p>Preview not available for this file type.</p>;
        }
    };

    return (
        <div className='containerAA'>
            <Spin spinning={loading} >
                <PageHeader
                    title="Gestion de publicité"
                    subtitle="Gérez les publicités, leurs médias et leur statut"
                    actions={<NewPub handleFunction={() => { LoadData(); }} services={undefined} />}
                />
                <div className="eb-table-wrap">
                    <div className="mb-3">
                        <SearchInput onSearch={LoadData} size='lg' placeholder='Saisissez pour effectuer une recherche' />
                    </div>
                    <DataTable
                        rows={dataTri}
                        columns={columns}
                        height={300}
                        onRowClick={handleRowClick}
                    />
                </div>
                <TableStatusBar count={dataTri.length} loading={loading} onRefresh={LoadData} />
                <InfoBar data={[
                    { label: 'Date Modif', value: arrierePlanSelected?.ModifDate },
                    { label: 'Nombre de Modif', value: arrierePlanSelected?.UpdateCount },
                    { label: 'Créé par', value: arrierePlanSelected?.CreatedBy },
                ]} />

                <FormDrawer
                    open={open}
                    onClose={handleClose}
                    title={`Modification de ${Pub?.Titre || ''}`}
                    hint="Les informations existantes sont pré-remplies. Modifiez les champs souhaités puis enregistrez."
                >
                    <FormPubUpdate file={fileToUpdate} handleFunction={() => { setOpen(false); LoadData() }} pub={Pub} />
                </FormDrawer>
                <Modal
                    open={openFileModal}
                    onClose={() => setOpenFileModal(false)}
                    title={`Aperçu — ${filesToView.length} fichier${filesToView.length > 1 ? 's' : ''}`}
                    footer={<Button onClick={() => setOpenFileModal(false)} variant="primary">Fermer</Button>}
                >
                    <div className="flex flex-col gap-3">
                        {filesToView.map((f, i) => (
                            <div key={i} className="rounded-lg overflow-hidden border border-[var(--eb-border)]">
                                {renderFilePreview(f.split(',')[0].split(':')[1]?.split(';')[0] || '', f)}
                            </div>
                        ))}
                        {filesToView.length === 0 && (
                            <p className="text-sm text-[var(--eb-text-muted)]">Aucun fichier associé.</p>
                        )}
                    </div>
                </Modal>
                <Modal
                    open={openServicesModal}
                    onClose={() => setOpenServicesModal(false)}
                    title={`Services de diffusion — ${servicesPubTitre}`}
                    footer={<Button onClick={() => setOpenServicesModal(false)} variant="primary">Fermer</Button>}
                >
                    <div className="flex flex-col gap-1.5">
                        {servicesPub.map((s: any) => (
                            <div key={s.CodeS}
                                className="flex items-center gap-2.5 px-3 py-2 rounded-lg border border-[var(--eb-border)]">
                                <Badge color="violet">{s.CodeS}</Badge>
                                <span className="text-sm text-[var(--eb-text)]">{s.Libelle}</span>
                            </div>
                        ))}
                        {servicesPub.length === 0 && (
                            <p className="text-sm text-[var(--eb-text-muted)]">Aucun service affecté à cette publicité.</p>
                        )}
                    </div>
                </Modal>
            </Spin>
        </div>
    );
}
